/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Price
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * Currency iso format
     * @type {string}
     * @memberof Price
     */
    currencyIso?: string;
    /**
     * Value of price in BigDecimal format
     * @type {number}
     * @memberof Price
     */
    value?: number;
    /**
     * Type of the price
     * @type {string}
     * @memberof Price
     */
    priceType?: PricePriceTypeEnum;
    /**
     * Value of price formatted
     * @type {string}
     * @memberof Price
     */
    formattedValue?: string;
    /**
     * Minimum quantity of the price value
     * @type {number}
     * @memberof Price
     */
    minQuantity?: number;
    /**
     * Maximum quantity of the price value
     * @type {number}
     * @memberof Price
     */
    maxQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    campaignCode?: string;
}


/**
 * @export
 */
export const PricePriceTypeEnum = {
    Buy: 'BUY',
    From: 'FROM',
    Base: 'BASE',
    Scaled: 'SCALED',
    Contract: 'CONTRACT',
    DiscountNormal: 'DISCOUNT_NORMAL',
    DiscountCampaign: 'DISCOUNT_CAMPAIGN',
    DiscountScaledcampaign: 'DISCOUNT_SCALEDCAMPAIGN',
    DiscountPromotion: 'DISCOUNT_PROMOTION'
} as const;
export type PricePriceTypeEnum = typeof PricePriceTypeEnum[keyof typeof PricePriceTypeEnum];


/**
 * Check if a given object implements the Price interface.
 */
export function instanceOfPrice(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PriceFromJSON(json: any): Price {
    return PriceFromJSONTyped(json, false);
}

export function PriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Price {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currencyIso': !exists(json, 'currencyIso') ? undefined : json['currencyIso'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'formattedValue': !exists(json, 'formattedValue') ? undefined : json['formattedValue'],
        'minQuantity': !exists(json, 'minQuantity') ? undefined : json['minQuantity'],
        'maxQuantity': !exists(json, 'maxQuantity') ? undefined : json['maxQuantity'],
        'campaignCode': !exists(json, 'campaignCode') ? undefined : json['campaignCode'],
    };
}

export function PriceToJSON(value?: Price | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currencyIso': value.currencyIso,
        'value': value.value,
        'priceType': value.priceType,
        'formattedValue': value.formattedValue,
        'minQuantity': value.minQuantity,
        'maxQuantity': value.maxQuantity,
        'campaignCode': value.campaignCode,
    };
}

